import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { getAdminBasePath, getAdminBaseRoute } from "../AdminRoutes";
import BatchExpire from "../../../../../components/subscription/batchExpire";
import SubscriptionInfo from "../../../../../components/subscription/subscriptionInfo";
export const getSubscriptionBasePath = () => `${getAdminBasePath()}/subscription`;
export const getSubscriptionBatchExpirePath = () => `${getSubscriptionBasePath()}/batchExpire`;
export const getSubscriptionInfoPath = () => `${getSubscriptionBasePath()}/info`;
export const getSubscriptionBaseRoute = () => `${getAdminBaseRoute()}/subscription`;
export const getSubscriptionBatchExpireRoute = () => `${getSubscriptionBaseRoute()}/batchExpire`;
export const getSubscriptionInfoRoute = () => `${getSubscriptionBaseRoute()}/info`;
const AdminSubscriptionsRoutes = () => {
    return (_jsxs(Switch, { children: [_jsx(Route, { component: BatchExpire, path: getSubscriptionBatchExpireRoute() }), _jsx(Route
            // @ts-expect-error - TS2769 - No overload matches this call.
            , { 
                // @ts-expect-error - TS2769 - No overload matches this call.
                component: SubscriptionInfo, path: getSubscriptionInfoRoute() })] }));
};
export default AdminSubscriptionsRoutes;
